// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__3J-Le","label":"label__25aDm","input":"input__3iM3l","label-text":"label-text__1cIQs","labelText":"label-text__1cIQs"};